export default class ParticleSystem {
  private origin: any
  private particles: any[]

  constructor(private p5: any, position: any, private particleType: any) {
    this.origin = position.copy()
    this.particles = []
  }

  addParticle(count: number = 1) {
    for (let i = 0; i < count; i++) {
      this.particles.push(new this.particleType(this.p5, this.origin))
    }
  }

  run() {
    for (var i = this.particles.length - 1; i >= 0; i--) {
      const particle = this.particles[i]
      particle.run()
      if (particle.isDead()) {
        this.particles.splice(i, 1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/graphics/ParticleSystem.ts